/**
 * Formatting helpers shared between storefront and admin.
 * UK locale (en-GB) for dates and currency.
 *
 * Moved from apps/admin/src/lib/format.ts in P11-T2.
 * formatTimestamp keeps the existing admin signature (nullable input,
 * "—" fallback) so call sites like OrderDetail.tsx that pass nullable
 * fields (fulfilled_at, issued_at) keep working without churn.
 */
const GBP = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
export function formatGBP(amountMinor) {
    return GBP.format(amountMinor / 100);
}
/**
 * Format an ISO-8601 datetime string as "YYYY-MM-DD HH:MM:SS" (UTC slice).
 * Returns "—" for null/undefined inputs (matches the table-cell empty
 * placeholder pattern used across admin pages).
 */
export function formatTimestamp(iso) {
    return iso ? iso.slice(0, 19).replace("T", " ") : "—";
}
/**
 * Format an ISO-8601 datetime as a UK-locale date ("08 May 2026").
 * Useful for storefront account pages where time-of-day is noise.
 * Returns "—" for null/undefined to match the formatTimestamp pattern.
 */
export function formatDate(iso) {
    if (!iso)
        return "—";
    return new Date(iso).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
    });
}
